import { Link } from "react-router-dom";
import Container from "components/container";
import Heading from "components/heading";
import { BasicSection, GridPanel1 } from "components/styles";
import styled from "@emotion/styled";

const ListPanel = styled.ul({
  paddingTop: "1.25rem",
  "& li": {
    marginLeft: "1.25rem",
    paddingLeft: "0.5rem",
    paddingTop: "0.25rem",
  },
  "& a": {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

const WhitePapersArticlesAndReferences = () => (
  <main>
    <Heading
      isHome={false}
      name="Nexus Risk Management"
      title={["White Papers,", "Articles and", "References"]}
    />
    <BasicSection background="light-blue">
      <Container>
        <GridPanel1>
          <div>
            <h2>References</h2>
            <ListPanel>
              <li>
                <Link
                  to="/documents/references/IAA Risk Book - Asset Liability Management.pdf"
                  target="_blank"
                >
                  IAA Risk Book - Asset Liability Management Techniques and
                  Practices for Insurance Companies, to be published in 2025 by
                  International Actuarial Association
                </Link>
              </li>
            </ListPanel>
          </div>
          <div>
            <h2>White Papers</h2>
            <ListPanel>
              <li>
                <Link
                  to="/documents/white-papers/Risk Management Overlay Strategies.pdf"
                  target="_blank"
                >
                  Risk Management Overlay Strategies: Changing the Way Investors
                  Think About Hedging Using the S&P 500<sup>&reg;</sup> Index
                  and CBOE Exchange Traded Options, published in March 2015 by
                  Chicago Board Options Exchange, Nexus Risk Management, and S&P
                  Dow Jones Indices.
                </Link>
              </li>
              <li>
                <Link
                  to="/documents/white-papers/Beyond Volatility - A New Way to Look at Risk Managed Index Strategy Performance.pdf"
                  target="_blank"
                >
                  Beyond Volatility: A New Way to Look at Risk Managed Index
                  Strategy Performance, published in October 2023 by S&P Dow
                  Jones Indices, Nexus Risk Management, and Cboe Global Markets.
                </Link>
              </li>
            </ListPanel>
          </div>
        </GridPanel1>
      </Container>
    </BasicSection>
  </main>
);

export default WhitePapersArticlesAndReferences;
